import { render } from "./DrawBoxAnnotation.vue?vue&type=template&id=03c65e68&scoped=true"
import script from "./DrawBoxAnnotation.vue?vue&type=script&lang=js"
export * from "./DrawBoxAnnotation.vue?vue&type=script&lang=js"

import "./DrawBoxAnnotation.vue?vue&type=style&index=0&id=03c65e68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c65e68"]])

export default __exports__